import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./index.css";
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { useAuth } from "./store/authProvider";
import ReactGA from "react-ga4";
import { router } from "./routes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const queryClient = new QueryClient({});

const firebaseConfig = {
  apiKey: "AIzaSyDlihBfS_lU7x1PRvy5Nv_CnprfGggzuFU",
  authDomain: "mhasool.firebaseapp.com",
  projectId: "mhasool",
  storageBucket: "mhasool.appspot.com",
  messagingSenderId: "692705062577",
  appId: "1:692705062577:web:ba6a83dc26c29c15507c90",
  measurementId: "G-ZEDQL96ZEB",
};

ReactGA.initialize("G-86HM9ZBE3B");

function App() {
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

  const isAuth = useAuth();
  const routes = createBrowserRouter(createRoutesFromElements(router(isAuth)));

  const { i18n } = useTranslation();

  // Set initial direction based on saved language
  useEffect(() => {
    const savedLang = localStorage.getItem('mahsool_language');
    const currentLang = savedLang === 'en' ? 'en' : 'ar';
    document.documentElement.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLang;
  }, []);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        {/* <ReactQueryDevtools initialIsOpen={true} /> */}
        <ToastContainer
          position="top-left"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          // rtl={true}
          rtl={i18n.language === 'ar'}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          style={{ fontSize: "14px", zIndex: 100000, fontWeight: 700 }}
        />
        <RouterProvider router={routes} />
      </QueryClientProvider>
    </>
  );
}

export default App;
